import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SORT_ASC, SORT_DESC} from '../../models/pipeline/steps/column_actions/sort_column';
import DataTable from './data_table';
import {columnActionEvent} from "../../services/query_builder_events";
import PIPELINE_STEPS from '../../utils/pipeline_steps';
import pipelineStepPropType from '../../utils/pipeline_step_proptype';

export default class ResultsTable extends Component {
    columnMenu = [
        {
            label: 'Rename',
            onClick: this.renameColumn.bind(this),
        },
        {
            label: 'Add Formula',
            onClick: this.editColumn.bind(this),
        },
        {
            label: 'Hide',
            onClick: this.hideColumn.bind(this),
        },
        {
            label: 'Sort',
            actions: [
                {
                    label: 'Sort Ascending',
                    icon: ({type}) => type === 'string' ? 'sort-text-asc' : 'sort-asc',
                    onClick: (column) => { this.sortColumn(column, SORT_ASC); }
                },
                {
                    label: 'Sort Descending',
                    icon: ({type}) => type === 'string' ? 'sort-text-desc' : 'sort-desc',
                    onClick: (column) => { this.sortColumn(column, SORT_DESC); }
                },
            ],
        },
    ];

    editColumn(column) {
        columnActionEvent.emit(PIPELINE_STEPS.EDIT_COLUMN, {parent: this.props.step, data: {column}});
    }

    hideColumn(column) {
        columnActionEvent.emit(PIPELINE_STEPS.HIDE_COLUMN, {parent: this.props.step, data: {column}});
    }

    renameColumn(column) {
        columnActionEvent.emit(PIPELINE_STEPS.RENAME_COLUMN, {parent: this.props.step, data: {column}});
    }

    sortColumn(column, direction) {
        columnActionEvent.emit(PIPELINE_STEPS.SORT_COLUMN, {parent: this.props.step, data: {column, direction}});
    }

    render() {
        const {data, showMenu, limit, ...otherProps} = this.props;
        return (
            <>
                <DataTable
                    data={data}
                    limit={limit || 10}
                    columnMenu={showMenu ? this.columnMenu : undefined}
                    {...otherProps}
                />
            </>
        )
    }
}

ResultsTable.propTypes = {
    data: PropTypes.object.isRequired,
    step: pipelineStepPropType.isRequired,
    limit: PropTypes.number,
    showMenu: PropTypes.bool,
    hasExecuted: PropTypes.bool,
    onExecute: PropTypes.func,  // only set for Query Builder
    editingPipelineStep: PropTypes.bool,
};

ResultsTable.defaultProps = {
    showMenu: true,
    hasExecuted: false,
    editingPipelineStep: false,
};
